import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PersonEmailService } from '../person-email.service';
import { PersonEmail } from '../person-email';
import { PersonService } from '@app/_components/person/person.service';

@Component({
    selector: 'app-person-email',
    templateUrl: './person-email.component.html',
    styleUrls: ['./person-email.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PersonEmailComponent implements OnInit {
    personId: any;
    persons: any;
    emailTypes: any;

	constructor(
		private personService: PersonService,
		private primengConfig: PrimeNGConfig,
		private personEmailService: PersonEmailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.personEmail = data.personEmail,
			this.personId = data.personId,
			this.statuses = personEmailService.statuses;
			this.emailTypes =  this.personService.emailTypes;
	}

	@Input() personEmail: PersonEmail;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	personEmailId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'personEmailId': [],
		'type': [{ type: 'required', message: 'Required' }],
		'emailAdr': [{ type: 'required', message: 'Required' }, { type: 'email', message: 'Please enter valid email' }],
		'personId': [],
	};

	ngOnInit() {
		this.fetchPersons();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole personEmail object
		if (this.personEmail) {
			this.personEmailId = this.personEmail.personEmailId;
			this.fixDates();
			this.form1.patchValue(this.personEmail);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.personEmailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.form1.value.personId = this.personId;
			this.personEmailService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personEmail = res.data.email;
						this.doAdd.emit(this.personEmail);
					},
					(err: any) => {
						console.log('personEmail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('personEmail: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.personEmailService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personEmail = res.data.email;
						this.doUpdate.emit(this.personEmail);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.personEmailService.delete(this.personEmail.personEmailId)
				.subscribe(
					(res: any) => {
						console.log('personEmail-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.personEmail);
					},
					(err: any) => {
						console.log('personEmail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			personEmailId: [this.personEmailId],
			type: ['', Validators.required],
			emailAdr: ['', Validators.compose([Validators.email, Validators.required])],
			personId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.personEmail.personEmailDate = moment(this.personEmail.personEmailDate).toDate();
	}
	
	fetchPersons() {
		if (!this.persons || this.persons === undefined || this.persons.length < 1) {
			try {
				this.personService.findAll()
					.subscribe(
						res => {
							console.log('findAllPersons: ' + JSON.stringify(res));
							this.persons = res.data.persons;
							return this.persons;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.persons);
		}
	}
}
